import { useNavigate } from 'react-router-dom';

import { useQuery } from '@tanstack/react-query';

import { getWizardInstanceById } from 'api/Wizard/Wizard';

export const useGetWizardInstance = ({ params = {}, options = {}, dependencies = [] }) => {
  const navigate = useNavigate();
  return useQuery(
    ['wizardInstance', ...dependencies],
    () => getWizardInstanceById(navigate, params),
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      keepPreviousData: true,
      ...options
    }
  );
};
